import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';

import PreviewStore from '../Store';
import Modal from '../../../../../../Modal';
import Button from '../../../../../../Form/Button';
import { T } from '../../../../../../../Translations';
import ModalStore from '../../../../../../Modal/Store';
import WithField from '../../../../../../../Resource/FormTemplates/Inputs/WithField';
import StringInput from '../../../../../../../Resource/FormTemplates/Inputs/StringInput';

export interface Props {
  modalStore: ModalStore;
  previewStore: PreviewStore;
}

const LearningCollectionDescriptionModal: React.FC<Props> = ({ modalStore, previewStore }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          additionalClasses="overflow-visible"
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Edit Description" />
            </h3>
          }
        >
          <div>
            {previewStore.learningCollectionStore.template
              .map((template) => (
                <div>
                  <WithField kind="string" name="description" fields={template.fields}>
                    {(field) => <StringInput field={field} />}
                  </WithField>
                </div>
              ))
              .getOrElse(() => (
                <></>
              ))}
            <div className="flex justify-end">
              <Button
                type="button"
                value="Done"
                onClick={modalStore.close}
                className={clsx(
                  'ml-5 rounded bg-teal-600 py-2.5 px-5 text-sm',
                  'text-white disabled:opacity-60',
                )}
              />
            </div>
          </div>
        </Modal>
      );
  }
};

export default observer(LearningCollectionDescriptionModal);
